import { t } from "i18next";
import { Controller } from "react-hook-form";
import { Input } from "ui";

import { StaffManagerFormAtomProps } from "../StaffManagerForm.types";

import styles from "../StaffManagerForm.module.scss";

const NameFields = ({ control }: StaffManagerFormAtomProps) => {
  return (
    <div className={styles.form_twoInputsBlock}>
      <Controller
        control={control}
        name="firstName"
        render={({ field: { value, onChange }, fieldState: { error } }) => (
          <Input
            value={value}
            onChange={onChange}
            label={t("First Name")}
            placeholder={t("Enter First Name")}
            errorMessage={error?.message}
            data-testid="staff-manager--firstName"
          />
        )}
      />

      <Controller
        control={control}
        name="lastName"
        render={({ field: { value, onChange }, fieldState: { error } }) => (
          <Input
            value={value}
            onChange={onChange}
            label={t("Last Name")}
            placeholder={t("Enter Last Name")}
            errorMessage={error?.message}
            data-testid="staff-manager--lastName"
          />
        )}
      />
    </div>
  );
};

export default NameFields;
